import React, { useState, useEffect, useRef } from "react";

const PageLevelRiverseTimer = ({ timerData }) => {
  // State to hold the total seconds remaining
  const [totalSeconds, setTotalSeconds] = useState(0);
  const intervalRef = useRef(null);

  // Calculate days, hours, minutes, and seconds from total seconds
  const daysRemaining = Math.floor(totalSeconds / (24 * 60 * 60));
  const hoursRemaining = Math.floor(
    (totalSeconds % (24 * 60 * 60)) / (60 * 60)
  );
  const minutesRemaining = Math.floor((totalSeconds % (60 * 60)) / 60);
  const secondsRemaining = totalSeconds % 60;

  // Helper function to pad numbers with leading zeros
  const padNumber = (num) => String(num).padStart(2, "0");

  // Pad the numbers
  const paddedDays = padNumber(daysRemaining);
  const paddedHours = padNumber(hoursRemaining);
  const paddedMinutes = padNumber(minutesRemaining);
  const paddedSeconds = padNumber(secondsRemaining);

  // Function to convert the object data into total seconds
  const calculateTotalSeconds = ({
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  }) => {
    return (
      days * 24 * 60 * 60 +
      hours * 60 * 60 +
      minutes * 60 +
      seconds
    );
  };

  // Set initial total seconds based on timerData
  useEffect(() => {
    if (timerData) {
      const total = calculateTotalSeconds(timerData);
      setTotalSeconds(total);
    } else {
      setTotalSeconds(0);
    }
  }, [timerData]);

  // Countdown effect — only starts/stops when totalSeconds crosses zero
  // Uses useRef for interval to avoid re-creating on every tick
  useEffect(() => {
    // If time expired, clear any running interval
    if (totalSeconds <= 0) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    // Interval already running — don't start another
    if (intervalRef.current) return;

    intervalRef.current = setInterval(() => {
      setTotalSeconds((prevTotalSeconds) => {
        if (prevTotalSeconds <= 1) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          return 0;
        }
        return prevTotalSeconds - 1;
      });
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
    // Only re-run when transitioning between zero and non-zero, or when timerData changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timerData, totalSeconds === 0]);

  return (
    <>
      <div className="d-flex rivers-timer">
        <div className="d-flex-column  align-items-center">
          <div className="d-flex align-items-center fs-4 timer-box">
            <p className="border  p-2 m-1">{paddedDays[0]}</p>
            <p className="border  p-2 m-1">{paddedDays[1]}</p>
            <span className="mx-2">:</span>
          </div>
          <span className="me-3 d-flex justify-content-center">Days</span>
        </div>

        <div className="d-flex-column align-items-center">
          <div className="d-flex align-items-center fs-4 timer-box">
            <p className="border  p-2 m-1">{paddedHours[0]}</p>
            <p className="border  p-2 m-1">{paddedHours[1]}</p>
            <span className="mx-2">:</span>
          </div>
          <span className="me-3 d-flex justify-content-center">Hours</span>
        </div>

        <div className="d-flex-column align-items-center">
          <div className="d-flex  align-items-center fs-4 timer-box">
            <p className="border  p-2 m-1">{paddedMinutes[0]}</p>
            <p className="border  p-2 m-1">{paddedMinutes[1]}</p>
            <span className="mx-2">:</span>
          </div>
          <span className="me-3 d-flex justify-content-center">Mins</span>
        </div>

        <div className="d-flex-column align-items-center">
          <div className="d-flex justify-content-center align-items-center fs-4 timer-box">
            <p className="border p-2 m-1">{paddedSeconds[0]}</p>
            <p className="border p-2 m-1">{paddedSeconds[1]}</p>
          </div>
          <span className="d-flex justify-content-center">Secs</span>
        </div>
      </div>
    </>
  );
};
export default PageLevelRiverseTimer;
